module.exports = __webpack_public_path__ + "media/victoria.55b349db.mp3";